import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import {action, computed} from 'mobx';
import {inject} from 'mobx-react';
import {Link} from 'react-router';

import {withI18n} from 'spa/Components/Context';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import './home-partners-section-for-digital.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomePartnersSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickBrowseServices - HomePartnersSectionForDigital')
  onClickBrowseServices() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Browse Services',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked Browse Services button', trackingData);
  }

  @computed get partnersImages() {
    const {i18n} = this.context;

    if (i18n.umRegion === 'UK') {
      return {
        lowResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585845236/b2c-art/home-2020/digital/img_homepage_partners.jpg',
        highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585845237/b2c-art/home-2020/digital/img_homepage_partners_2x.jpg',
        highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585845237/b2c-art/home-2020/digital/img_homepage_partners_3x.jpg',
      };
    }

    return {
      lowResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585839110/b2c-art/home-2020/digital/img_homepage_partners_fr.jpg',
      highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585839110/b2c-art/home-2020/digital/img_homepage_partners_fr_2x.jpg',
      highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585839110/b2c-art/home-2020/digital/img_homepage_partners_fr_3x.jpg',
    };
  }

  @computed get contentText() {
    const {i18n} = this.context;

    if (i18n.umRegion === 'UK') {
      return i18n._x('Discover treatments and sessions from your favourite brands. Think long-lasting nail treatments from OPI, CND and Manucurist, fitness sessions from boutique gym Frame, and facials from the skincare masters, Dermalogica.', 'Home partners section paragraph');
    }

    return i18n._x('Discover treatments from your favourite brands. Think long-lasting nail treatments from Manucurist, and facials from the skincare masters, Dermalogica.', 'Home partners section paragraph');
  }

  render() {
    const {i18n} = this.context;
    const {contentText, partnersImages} = this;

    return (
      <div className="home-partners-section home-content-section row">
        <div className="home-content-section__cell home-content-section__cell-image home-partners-section__cell-image home-partners-section__cell-image--block">
          <ProgressiveImage
            lowResImg={partnersImages.lowResImg}
            highResImg={partnersImages.highResImg}
            highResImg2x={partnersImages.highResImg2x}
          />
        </div>
        <div className="home-content-section__cell home-content-section__cell-text home-content-section__cell-text--extra-padded-right">
          <div className="home-content-section__text-content home-content-section__text-content--wide">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('We partner with the best', 'Home partners section title')}</h2>
            <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">
              {contentText}
            </p>
            <Link
              className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
              onClick={this.onClickBrowseServices}
              to={`/${i18n.lc}/treatments`}
            >
              {i18n._x('Browse services', 'Homepage browse services button')}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePartnersSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomePartnersSectionForDigital.jsx